import { render, staticRenderFns } from "./breadcrumds.vue?vue&type=template&id=15aa6a24&scoped=true&"
import script from "./breadcrumds.vue?vue&type=script&lang=js&"
export * from "./breadcrumds.vue?vue&type=script&lang=js&"
import style0 from "./breadcrumds.vue?vue&type=style&index=0&id=15aa6a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aa6a24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
